import localDB from "./localDB";
let GLOBAL = require('./globals');

const DataHelper = {
    async get(url, res,is_auth=false) {
        await fetch(`${GLOBAL.BASE_URL}api/${url}`, {
            method: 'GET',
            headers: {'Authorization': localDB.sessionToken()}
        }).then((response) => response.json())
            .then((responseData) => res(responseData))
            .catch((err) => {
                console.log(err)
                res(err)
            });
    },
    async patch(data, url, res) {
        await fetch(`${GLOBAL.BASE_URL}api/${url}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json())
            .then((responseData) => res(responseData))
            .catch((err) =>{
                console.log(err)
                res(err)
            });
    },
    async uploadFile(file, url, res) {
        let data = new FormData();
        data.append("file", file);
        await fetch(`${GLOBAL.BASE_URL}api/${url}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            'dataType': 'json',
            body: JSON.stringify(file)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
};

export default DataHelper;


// WEBPACK FOOTER //
// ./src/data/DataHelper.js